import { createAction, props } from '@ngrx/store';
import { AppStateEntity } from './app-state.models';

export const init = createAction('[AppState Page] Init');

export const setUserSession = createAction(
  '[AppState/API] setUserSession',
  props<{
    id: string | null;
    user: any;
    case?: any;
  }>()
);

export const loadAppStateSuccess = createAction(
  '[AppState/API] Load AppState Success',
  props<{ appState: AppStateEntity[] }>()
);

export const loadAppStateFailure = createAction(
  '[AppState/API] Load AppState Failure',
  props<{ error: any }>()
);

export const updateUser = createAction(
  '[AppState/API] updateUser',
  props<{ payload: any }>()
);


export const signOut = createAction(
  '[AppState/API] signout'
);

export const signOutSuccess = createAction(
  '[AppState/API] signout success'
)
export const signOutFailure = createAction(
  '[AppState/API] signout failure'
)

export const appConfig = createAction(
  '[AppState/CONFIG] Add Config',
  props<{ configurations: any }>()
);

//util actions

export const utilApiTrigger = createAction(
  '[AppState/API] Util API Trigger',
  props<any>()
);

export const utilApiSuccess = createAction(
  '[AppState/API] Util API Success',
  props<{ id: number; code: string; response: any ,apiPayload:any}>()
);

export const utilApiFailure = createAction(
  '[AppState/API] Util API Failure',
  props<{ id: number; code: string; error: any ,apiPayload:any}>()
);